import apiClient from "./ApiInterceptor";

export const fetchUserWrapped = async (user_id, year) => {
    const response = await apiClient.get(`/users/${user_id}/wrapped/${year}`);
    return response;
};
